// src/com/auto_using_car_info/AutoUsingCarInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_USING_CAR_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-24 13:49:08 using DbdbTap.
 ************************************************ */

const AUTO_USING_CAR_INFO_LIST_PART = gql`
fragment AutoUsingCarInfoListPart on AutoUsingCarInfo {
    dcCd
    planDate
    vehTypeId
    vehTypeName
    rentYn
    usingCarCnt
    regDate
    regUser
    dcName
    vehTypeAlias
    regUserName
}
`;


export const LIST_AUTO_USING_CAR_INFO = gql`
${AUTO_USING_CAR_INFO_LIST_PART}
query ListAutoUsingCarInfo($dcCd:String!, $planDate:String!) {
    autoUsingCarInfoList(dcCd:$dcCd, planDate:$planDate) {
        ...AutoUsingCarInfoListPart
    }
}
`;

// autoUsingCarInfoListToEdit(dcCd:String!, planDate:String!): [AutoUsingCarInfo]!
export const LIST_AUTO_USING_CAR_INFO_TO_EDIT = gql`
query ListAutoUsingCarInfoToEdit($dcCd:String!, $planDate:String!) {
    autoUsingCarInfoListToEdit(dcCd:$dcCd, planDate:$planDate) {
        dcCd
        planDate
        vehTypeId
        vehTypeName
        usingCarCnt
        dcName
        vehTypeAlias
    }
}
`;

// autoUsingCarInfoLatestList(dcCd:String!): [AutoUsingCarInfo]!
export const LIST_AUTO_USING_CAR_INFO_LATEST = gql`
query ListAutoUsingCarInfoLatest($dcCd:String!) {
    autoUsingCarInfoLatestList(dcCd:$dcCd) {
        dcCd
        planDate
        vehTypeId
        usingCarCnt
    }
}
`;


export const GET_AUTO_USING_CAR_INFO = gql`
${AUTO_USING_CAR_INFO_LIST_PART}
query GetAutoUsingCarInfo($dcCd:String!, $planDate:String!, $vehTypeId:String!) {
    autoUsingCarInfoItem(dcCd:$dcCd, planDate:$planDate, vehTypeId:$vehTypeId) {
        ...AutoUsingCarInfoListPart
    }
}
`;

// autoUsingCarInfoUpload(autoUsingCarInfo: [InputAutoUsingCarInfoAdd]!): ResponseWithAutoUsingCarInfoResList!
export const UPLOAD_AUTO_USING_CAR_INFO = gql`
mutation UploadAutoUsingCarInfo($autoUsingCarInfo:[InputAutoUsingCarInfoAdd]!) {
    autoUsingCarInfoUpload(autoUsingCarInfo: $autoUsingCarInfo) {
        ok
        message
        list {
            ok
            message
            dcCd
            planDate
            vehTypeId
        }
    }
}
`;

export const REMOVE_AUTO_USING_CAR_INFO = gql`
mutation RemoveAutoUsingCarInfo($autoUsingCarInfo:InputAutoUsingCarInfoRemove!) {
	autoUsingCarInfoRemove(autoUsingCarInfo: $autoUsingCarInfo) {
		ok
		message
	}
}
`;

/*

extend type Query {
	autoUsingCarInfoList(dcCd:String!, planDate:String!): [AutoUsingCarInfo]!
    autoUsingCarInfoListToEdit(dcCd:String!, planDate:String!): [AutoUsingCarInfo]!
	autoUsingCarInfoItem(dcCd:String!, planDate:String!, vehTypeId:String!): AutoUsingCarInfo
}

extend type Mutation {
	autoUsingCarInfoUpload(autoUsingCarInfo: [InputAutoUsingCarInfoAdd]!): ResponseWithAutoUsingCarInfoResList!
	autoUsingCarInfoRemove(autoUsingCarInfo: InputAutoUsingCarInfoRemove!): CommonResponse!
}

type AutoUsingCarInfo {
	dcCd: String!
	planDate: String!
	vehTypeId: String!
	dcName: String
	vehTypeName: String
    vehTypeAlias: String
	rentYn: String
	usingCarCnt: Int
	regDate: String
	regUser: String
	regUserName: String
}

# Add, Edit or Remove based on the record status and usingCarCnt
input InputAutoUsingCarInfoAdd {
	dcCd: String!
	planDate: String!
	vehTypeId: String!
	usingCarCnt: Int
}

input InputAutoUsingCarInfoRemove {
	dcCd: String!
	planDate: String!
	vehTypeId: String!
}

# Batch upload response list's own item
type AutoUsingCarInfoResponse {
	ok: Boolean!
	message: String
    dcCd: String!
    planDate: String!
    vehTypeId: String!
}

type ResponseWithAutoUsingCarInfoResList {
    ok: Boolean!
    message: String
    list: [AutoUsingCarInfoResponse]!
}




*/